import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { MultiProductCta } from './MultiProductCta';
export const MultiProducts = ({ multiProduct }) => {
    const product1 = multiProduct.products[0];
    const product2 = multiProduct.products[1];
    const selectedVariant1 = product1.selectedVariant;
    const selectedVariant2 = product2.selectedVariant;
    const [selectedItem1, setSelectedItem1] = useState(selectedVariant1.selectedItem);
    const [selectedItem2, setSelectedItem2] = useState(selectedVariant2.selectedItem);
    function selectSize(ean) {
        if (selectedVariant1.items.find((item) => item.ean === ean)) {
            setSelectedItem1(selectedVariant1.items.find((item) => item.ean === ean));
        }
        else {
            setSelectedItem2(selectedVariant2.items.find((item) => item.ean === ean));
        }
    }
    // Listen on size change event
    useEffect(() => {
        document.querySelectorAll('input[data-size]').forEach((sizeInput) => {
            sizeInput.addEventListener('click', (e) => {
                const ean = e.target.value;
                selectSize(ean);
            });
        });
    }, []);
    return (_jsx(MultiProductCta, { selectedVariant1: selectedVariant1, selectedVariant2: selectedVariant2, selectedItem1: selectedItem1, selectedItem2: selectedItem2 }));
};
export const renderMultiProducts = () => {
    document.querySelectorAll('[data-multi-product]').forEach((productContainer) => {
        // The product state is either on the button (ie in modals) or global (product page)
        const product = JSON.parse(productContainer.dataset.multiProduct);
        productContainer.querySelectorAll('[data-multi-product-cta]').forEach((ctaContainer) => {
            createRoot(ctaContainer).render(_jsx(MultiProducts, { multiProduct: product }));
        });
    });
};
